import { useState, useRef, useEffect } from "react";
import { useTranslation } from "@i18n";
import { scrollToElement } from "@/utils/GlobalJavascriptFunction";
import CarDetailsSection from "./components/carDetailsSection/CarDetailsSection";
import FAQ from "@/pages/home/homePageComponents/components/FAQ/FAQ";
import stl from "./NewPostView.module.css";
import AdNumber from "./components/leftColumn/components/adNumber/AdNumber";
import { CDN_LINK } from "@globalConfig";
import { oldImageViewEvent } from "@/utils/dataLayerEvents";
import LazyLoadComponent from "@hooks/LazyLoadComponent";
import loadable from "@loadable/component";
import { useSearchParams } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import LessThanMarket from "./components/leftColumn/components/lessThanMarket/LessThanMarket";
import LabelsCA from "./components/leftColumn/components/labelsCA/LabelsCA";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { thumbUrl } from "@/utils/imagesHelpers";
import useIsMobile from "@hooks/useIsMobile";
import PaymentTabBox from "./components/leftColumn/components/paymentTabBox/PaymentTabBox";
import NewPostBigSlider from "./components/newPostBigSlider/NewPostBigSlider";
import SimilarPosts from "@/pages/post/PostViewComponents/components/SimilarPosts/SimilarPosts";
import { getAndClearTrackingReferralParams } from "@hooks/useHashToLocalStoreEvent";
import { useChatBot } from "@hooks/useChatBot";
import useHelpers from "@hooks/useHelpers";
import WithScrollToTop from "@/common/HOCs/WithScrollToTop/WithScrollToTop";
import BreadCrumb from "@componentsShared/BreadCrumb";
import { useRecentlyViewedContext } from "@/_MiniApps/RecentlyViewedContext/RecentlyViewedContext";

const fallback = {
    fallback: "...",
};
export const CarReportSection = loadable(
    () => import("./components/carReportSection/CarReportSection"),
    fallback
);

export const AdSection = loadable(
    () => import("./components/adSection/AdSection"),
    fallback
);

const LimitedAvaInfoBox = loadable(
    () =>
        import(
            "../../../components/limitedAvailabilityComponent/components/LimitedAvaInfoBox/LimitedAvaInfoBox"
        ),
    fallback
);
const ShareNP = loadable(
    () => import("./components/leftColumn/components/shareNP/ShareNP"),
    fallback
);

const InspectionView = loadable(
    () => import("@/pages/post/PostViewComponents/components/InspectionView/InspectionView"),
    fallback
);
const CashPayment = loadable(
    () => import("./components/leftColumn/components/cashPayment/CashPayment"),
    fallback
);
const DmanProgram = loadable(
    () => import("./components/dmanProgram/DmanProgram"),
    fallback
);
const TfaseelAndRportHeader = loadable(
    () => import("./components/tfaseelAndRportHeader/TfaseelAndRportHeader"),
    fallback
);
const MobilePayment = loadable(
    () => import("./components/mobilePayment/MobilePayment"),
    fallback
);
const LimitedAvailability = loadable(
    () =>
        import(
            "./components/leftColumn/components/limitedAvailability/LimitedAvailability"
        ),
    fallback
);
const PostViewCampaign = loadable(
    () => import("./components/PostViewCampaign/PostViewCampaign"),
    fallback
);
const Story = loadable(
    () => import("../../../components/sharedComponents/Story/Story"),
    fallback
);
const WarrantyAndDealerSection = loadable(
    () =>
        import("./components/WarrantyAndDealerSection/WarrantyAndDealerSection"),
    fallback
);
const LeftColumn = loadable(
    () => import("./components/leftColumn/LeftColumn"),
    fallback
);
const AddToFavoriteButton = loadable(
    () => import("@/common/HOCs/AddToFavorite/AddToFavoriteButton"),
    fallback
);

const NewPostView = (props) => {
    useChatBot();
    const isMobile = useIsMobile();
    const { t } = useTranslation(["web_post_view", "web_common"]);
    const { createUrl, createUrlAbsolute } = useHelpers();
    const [searchParams] = useSearchParams();
    // Props Data
    const {
        details,
        gallery,
        quality,
        options,
        inspection,
        story,
        faqs,
        footer,
    } = props.postData || {};
    const hasCampaign = details?.campaigns;
    const hasDaman = details?.details_card?.is_new?.id === 0;
    const g4_data = props?.postData?.g4Data;
    const isUsed = g4_data?.post_condition === "used";

    //   refs
    const carInfoRef = useRef();
    const carReportRef = useRef();
    const hashObject = getAndClearTrackingReferralParams();
    // end refs

    //   state
    const [has360Flag, setHas360Flag] = useState(false);
    const [activeReport, setActiveReport] = useState(0);
    const [activeInspectionIndex, setActiveInspectionIndex] = useState(0);
    const [inspectReport, setInspectReport] = useState(false);
    const [activeInpectionTab, setActiveInpectionTab] = useState("Itab0");
    const [showStory, setShowStory] = useState(false);
    const [PaymentTypeFlag, setPaymentTypeFlag] = useState("cash");
    const [openBigGall, setOpenBigGall] = useState(false);


    // End state

    const { addCarIDtoViewedList, renderRecentlyViewedCars } = useRecentlyViewedContext();


    useEffect(() => {
        addCarIDtoViewedList(details?.id);
    }, [details?.id]);

    useEffect(() => {
        const bigGallView = hashObject?.bigGallView;
        if (bigGallView && parseInt(bigGallView)) {
            setOpenBigGall(true);
        }
    }, [hashObject?.bigGallView, gallery?.images?.[0]?.img_url]);

    useEffect(() => {
        if (g4_data) {
            trackEvents("view_post", {
                ...g4_data,
                ...hashObject,
                is_rec: !!hashObject.is_rec,
                post_trim: g4_data.post_ext,
                post_url: window.location.href,
                inventory_type_string: g4_data?.inventory_type_string,
                section_type: hashObject.section_type
            });
        }
    }, [g4_data]);

    //   functions
    useEffect(() => {
        const flippingFactor =
            document.querySelector("body")?.attributes?.dir?.value !== "ltr" ? -1 : 1;

        activeInspectionIndex != activeInpectionTab.split("Itab")[1] &&
            setActiveInspectionIndex(activeInpectionTab.split("Itab")[1]);

        document.getElementById("scrollMeNow") != null &&
            document.getElementById("scrollMeNow").scrollTo({
                top: document.getElementById(activeInpectionTab)?.offsetTop - 140,
            });

        if (
            document.getElementById("scrollVerUlMN") != null &&
            window.innerWidth <= 1024
        ) {
            document.getElementById("scrollVerUlMN")?.scrollTo({
                left:
                    flippingFactor *
                    (parseInt(activeInpectionTab.split("Itab")[1]) - 1) *
                    55,
                behavior: "smooth",
            });
        }
    }, [activeInpectionTab]);

    const setActiveInspectionIndexFunction = (val) => {
        setActiveInspectionIndex(undefined);
        setActiveInspectionIndex(val);
        setActiveInpectionTab("Itab" + val);
    };

    function getBreadcrumb() {
        const { brand, model, year } = props?.postData?.analytics || {};
        const brandSlug = brand?.slugify();
        const modelSlug = model?.slugify();

        const breadcrumbLinks = [
            {
                title: t("سيارات و مركبات", { ns: "web_post_view" }),
                link: createUrl("/autos"),
                event: () => trackEvents("browse_cars", {
                    referral_location: "Post View",
                    category_path: `autos>all`
                }),
            },
            {
                title: details?.details_card?.make?.name,
                link: createUrl(`/autos/${brandSlug}`),
                event: () => trackEvents("browse_cars", {
                    referral_location: "Post View",
                    browse_variant: "make",
                    variant_value: brandSlug,
                    category_path: `autos>${brandSlug}`
                }),
            },
            {
                title: details?.details_card?.model?.name,
                link: createUrl(`/autos/${brandSlug}/${modelSlug}`),
                event: () => trackEvents("browse_cars", {
                    referral_location: "Post View",
                    browse_variant: "model",
                    variant_value: modelSlug,
                    category_path: `autos>${brandSlug}>${modelSlug}`,
                }),
            },
            {
                title: `${year}`,
                link: createUrl(`/autos/${brandSlug}/${modelSlug}/${year}`),
                event: () => trackEvents("browse_cars", {
                    referral_location: "Post View",
                    browse_variant: "year",
                    variant_value: year,
                    category_path: `autos>${brandSlug}>${modelSlug}>${year}`,
                }),
            },
        ];

        return <BreadCrumb className="mt-1" links={breadcrumbLinks} />;
    }


    return (
        <>
            <>
                {inspectReport && (
                    <InspectionView
                        scrollViewId={(val) => {
                            setActiveInspectionIndex(val.split("Itab")[1]);
                        }}
                        activeInpectionTab={activeInpectionTab}
                        closeReport={() => {
                            setInspectReport(false);
                        }}
                        activeInspectionIndex={activeInspectionIndex}
                        setNewActiveIndex={(val) => {
                            setActiveInspectionIndexFunction(val);
                        }}
                        notes={inspection?.maintained_notes}
                        date={inspection?.report_date}
                        data={
                            inspection && inspection.car_report && inspection.external_body
                                ? [...inspection.car_report, inspection.external_body]
                                : []
                        }
                        g4_data={g4_data}
                    />
                )}

                {!isMobile && getBreadcrumb()}

                <div className={stl.postViewContainer}>
                    <div className={[stl.container, "container", stl.postMainColumns].join(" ")}>
                        <div>
                            <div className={[stl.sliderHeighCls, stl.noRad].join(" ")}>
                                {props?.postData?.details_section?.title}
                                <NewPostBigSlider
                                    openInFull={openBigGall}
                                    g4_data={g4_data || {}}
                                    hasCampaign={hasCampaign}
                                    isTrackingView={props.isTrackingView}
                                    postData={props.postData}
                                    isLimited={details?.limited_quantity}
                                    video={
                                        props?.postData?.video?.video_link &&
                                        props?.postData?.video
                                    }
                                    title={details?.h1}
                                    tags={details?.tags}
                                    id360={props?.postData?.gallery?.spin_code}
                                    showCamera360={props?.postData?.gallery?.has_spin}
                                >
                                    {gallery?.images &&
                                        gallery?.images?.map((sliderItem, i) => {
                                            return (
                                                <ProgressiveImage
                                                    key={i}
                                                    img_big_url={sliderItem.img_big_url}
                                                    progressiveSmallImage={
                                                        i === 0 &&
                                                        thumbUrl(
                                                            sliderItem?.img_url,
                                                            "online-v1",
                                                            isMobile ? "0x99" : "0x300"
                                                        )
                                                    }
                                                    src={thumbUrl(
                                                        sliderItem?.img_url,
                                                        "online-v1",
                                                        isMobile ? "0x426" : "0x683"
                                                    )}
                                                    data-src={thumbUrl(
                                                        sliderItem?.img_url,
                                                        "online-v1",
                                                        isMobile ? "0x426" : "0x683"
                                                    )}
                                                    data-img_thumb_url={sliderItem.img_thumb_url}
                                                    data-mrk={sliderItem.type === "campaign"}
                                                    data-camera={i === 0 && has360Flag}
                                                    data-video={
                                                        sliderItem.type === "video" ||
                                                            sliderItem.type === "youtube"
                                                            ? sliderItem.video_link
                                                            : undefined
                                                    }
                                                    alt={props?.postData?.details?.h1}
                                                    onClick={() =>
                                                        oldImageViewEvent(
                                                            sliderItem.type === "video"
                                                                ? "Video View"
                                                                : "Image View"
                                                        )
                                                    }
                                                />
                                            );
                                        })}
                                </NewPostBigSlider>
                            </div>

                            {hasCampaign && (
                                <PostViewCampaign
                                    newCampaignData={details?.campaigns}
                                    campaignText={props.campaignText}
                                />
                            )}

                            {/* mobile HTML */}
                            {isMobile && <div className={"m-show"}>
                                {getBreadcrumb()}
                                {isMobile && (
                                    <h1 className={stl.carNameMobile}>{details?.h1}</h1>
                                )}
                                {!props.isTrackingView && details?.low_mileage_text && (
                                    <LessThanMarket lowMileage={details?.low_mileage_text} />
                                )}
                                {!props.isTrackingView && <LabelsCA tags={details?.tags} />}

                                {props.isTrackingView && (
                                    <div className={stl.trackingPrice}>
                                        <div>
                                            <strong>
                                                {t("سعر الكاش", { ns: "web_post_view" })}
                                            </strong>
                                            <span
                                                style={{
                                                    color:
                                                        footer?.remaining_price <= 0 ? "" : "#00B64E",
                                                }}
                                            >
                                                {footer?.total_price
                                                    ? footer?.total_price
                                                    : props.postData.price?.vat_price?.text}
                                                <span>
                                                    {t("ريال", {
                                                        ns: "web_post_view",
                                                    })}
                                                </span>
                                            </span>
                                        </div>

                                        {searchParams.get("isCancelled") === "true" ? (
                                            <div>
                                                <span className={stl.isCancelled}>
                                                    {" "}
                                                    {t("تم إلغاء الطلب", {
                                                        ns: "web_post_view",
                                                    })}
                                                </span>
                                            </div>
                                        ) : footer?.remaining_price <= 0 ? (
                                            <div>
                                                <span className={stl.fullypaid}>
                                                    {" "}
                                                    {t("مدفوع كاملاً", {
                                                        ns: "web_post_view",
                                                    })}
                                                </span>
                                            </div>
                                        ) : (
                                            footer?.remaining_price && (
                                                <div>
                                                    <strong>
                                                        {t("المبلغ المتبقي", { ns: "web_post_view" })}
                                                    </strong>
                                                    <span>
                                                        {footer?.remaining_price}
                                                        <span>
                                                            {t("ريال", {
                                                                ns: "web_post_view",
                                                            })}
                                                        </span>
                                                    </span>
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}
                                {!props.isTrackingView && (
                                    <>
                                        {details?.limited_quantity &&
                                            details?.details_card?.is_new?.id ? (
                                            <LimitedAvailability
                                                priceSection={props?.postData?.price}
                                                ShowStory={() => setShowStory(true)}
                                                g4_data={g4_data}
                                            />
                                        ) : details?.have_finance ? (
                                            <>
                                                {isMobile && (
                                                    <PaymentTabBox
                                                        isUsed={isUsed}
                                                        hidePaymentBtn
                                                        post={details}
                                                        priceSection={props?.postData?.price}
                                                        postId={details?.id}
                                                        postTitle={details?.title}
                                                        ShowStory={() => setShowStory(true)}
                                                        setPaymentTypeFlag={(val) =>
                                                            setPaymentTypeFlag(val)
                                                        }
                                                        titleForPaymentBox={
                                                            PaymentTypeFlag !== "cash"
                                                                ? story?.finance_story.title
                                                                : story?.cash_story.title
                                                        }
                                                        arboun={footer?.arboun}
                                                        reserved={footer?.reserved}
                                                        footer={footer}
                                                        g4_data={g4_data}
                                                        car_condition={!(details?.details_card?.is_new.id) ? "used" : (details?.is_chinese) ? "chinese" : "new"}
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            //)}/>
                                            <CashPayment
                                                priceSection={props?.postData?.price}
                                                postId={details?.id}
                                                postTitle={details?.title}
                                                hidePaymentBtn
                                                ShowStory={() => setShowStory(true)}
                                                postData={props?.postData}
                                                g4_data={g4_data}
                                                footer={footer}
                                            />
                                        )}
                                    </>
                                )}
                                {!props.isTrackingView && (
                                    <LazyLoadComponent
                                        loadComponent={() => (
                                            <>
                                                <AddToFavoriteButton
                                                    isFromPostView={true}
                                                    postId={details?.id}
                                                    className={[
                                                        stl.FavoriteButtonMobile,
                                                        "m-show",
                                                    ].join(" ")}
                                                    g4_data={g4_data}
                                                />
                                                <ShareNP
                                                    postData={props.postData}
                                                    title={details?.title}
                                                    postDynamicLink={createUrlAbsolute(`/cardetail/${details?.id}`)}
                                                    mobileShare
                                                />
                                            </>
                                        )}
                                    />
                                )}
                            </div>}
                            {/* mobile HTML */}

                            {isMobile && hasDaman && (
                                <LazyLoadComponent
                                    loadComponent={() => (
                                        <DmanProgram qualitySection={quality} g4_data={g4_data} />
                                    )}
                                />
                            )}
                            {!isMobile && hasDaman && (
                                <DmanProgram qualitySection={quality} g4_data={g4_data} />
                            )}

                            {isUsed && (
                                <TfaseelAndRportHeader
                                    isInspectionAvailable={true}
                                    activeReport={activeReport}
                                    setActive={(val) => {
                                        setActiveReport(undefined);
                                        val == 0 && scrollToElement(carInfoRef.current, -100);
                                        val == 1 && scrollToElement(carReportRef.current, -100);
                                        let val2 = val;
                                        setTimeout(() => {
                                            setActiveReport(val2);
                                        }, 700);
                                    }}
                                />
                            )}
                            <div ref={carInfoRef}>
                                <CarDetailsSection
                                    screen_view_referral={props.screen_view_referral}
                                    sections={options?.options}
                                    carDetails={details?.details_card}
                                    fuelEco={
                                        props.postData?.fuel &&
                                        props.postData.fuel.length !== 0 &&
                                        Object.keys(props.postData?.fuel).length != 0 &&
                                        props.postData?.fuel
                                    }
                                    mojazData={details?.mojaz_report}
                                    g4_data={props.postData?.g4Data}
                                />
                            </div>

                            <div ref={carReportRef}>
                                {
                                    <LazyLoadComponent
                                        loadComponent={() => (
                                            <>
                                                <WarrantyAndDealerSection
                                                    warranty_card={details?.warranty_card}
                                                />
                                                {details?.id && (
                                                    <CarReportSection
                                                        postId={details?.id}
                                                        inspection={inspection}
                                                        clickFunction={(val) => {
                                                            setInspectReport(true);
                                                            setActiveInpectionTab(val);
                                                        }}
                                                        g4_data={g4_data}
                                                    />
                                                )}
                                            </>
                                        )}
                                    />
                                }
                            </div>


                        </div>

                        <div>
                            {!isMobile && (
                                <LeftColumn
                                    isTrackingView={props.isTrackingView}
                                    isUsed={isUsed}
                                    setPaymentTypeFlag={(val) => setPaymentTypeFlag(val)}
                                    titleForPaymentBox={
                                        PaymentTypeFlag !== "cash"
                                            ? story?.finance_story.title
                                            : story?.cash_story.title
                                    }
                                    scrollToMayzat={() =>
                                        scrollToElement(
                                            document.getElementById("scrollMeMazeedNew"),
                                            -100
                                        )
                                    }
                                    ShowStory={() => setShowStory(true)}
                                    postData={props.postData}
                                    mostPopular={options?.most_popular}
                                    isCancelled={searchParams.get("isCancelled") === "true"}
                                    g4_data={g4_data}
                                />
                            )}
                        </div>
                    </div>
                    <SimilarPosts postId={details?.id} />

                    {renderRecentlyViewedCars(stl.recentViewsContainer)}

                    {isUsed && (
                        <LazyLoadComponent loadComponent={() => <AdSection />} />
                    )}
                    <div className={stl.faqContainer}>
                        <FAQ faqs={faqs} isHomePage />
                    </div>
                    <div className="m-show">
                        <AdNumber
                            adNumber={details?.id}
                            isTrackingView={props.isTrackingView}
                        />
                        {details?.limited_quantity && <LimitedAvaInfoBox />}
                    </div>
                </div>
            </>
            {showStory && (
                <Story
                    showStoryMode={showStory}
                    closeStory={() => setShowStory(false)}
                    BGColor={
                        PaymentTypeFlag === "cash"
                            ? "linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%)"
                            : ""
                    }
                >
                    {PaymentTypeFlag !== "cash"
                        ? story?.finance_story.data.map((story, idx) => {
                            return (
                                <div key={"stry" + idx} className="singleStry">
                                    <strong style={{ textalign: "center" }}>
                                        {story?.finance_story.title}
                                    </strong>

                                    <img src={story.image} alt="story" />
                                </div>
                            );
                        })
                        : props?.postData?.story?.cash_story?.data.map((story, idx) => {
                            return (
                                <div
                                    key={"stry" + idx}
                                    className="singleStry"
                                    data-color="linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%);"
                                >
                                    <strong style={{ textalign: "center" }}>
                                        {props?.postData?.story?.cash_story?.title}
                                    </strong>
                                    <img
                                        src={props?.postData?.story?.cash_story?.img}
                                        alt="story"
                                    />
                                </div>
                            );
                        })}
                </Story>
            )}
            {!props.isTrackingView && isMobile && (
                <div className="m-show">
                    <MobilePayment
                        postId={details?.id}
                        arboun={footer?.arboun}
                        reserved={footer?.reserved}
                        have_finance={details?.have_finance}
                        limited_quantity={details?.limited_quantity}
                        footer={footer}
                        isNew={details?.details_card?.is_new.id}
                        canTestDrive={details?.can_test_drive}
                        testDriveDetails={details?.test_drive_box}
                        postTitle={details?.title}
                        postData={props?.postData}
                        g4_data={g4_data}
                        bTop
                        closePaymntPopup={(fun) => fun}
                        chatBtn={
                            <button
                                style={{ display: "none" }}
                                id="pingpongchat"
                                className={[stl.chatBtn].join(" ")}
                                onClick={() => window.fcWidget.open()}
                            >
                                <i />
                                {t("الدردشة الفورية", { ns: "web_post_view" })}
                            </button>
                        }
                    />
                </div>
            )}
            <WithScrollToTop renderFunction={({ onClick, isMouseOver }) =>
            (
                <div onClick={onClick} className={isMouseOver ? 'isMouseOver' : ''}>
                    <img
                        width="40px"
                        src={CDN_LINK + "/assets/images/Backtotop.svg"}
                        alt="Back To Top"
                    />
                </div>
            )}
            />
        </>
    );
};
export default NewPostView;
